<template>
  <div id="grand-expenses-report" class="expenses-report">
    <div class="header-bar">
      <h2>Expenses Report</h2>
      <div class="actions">
        <button class="exclude-print" @click="open_add_modal">
          + Add Expense
        </button>
        <button
          class="exclude-print"
          @click="
            printReport(
              'grand-expenses-report',
              'ExpenseReport' + filters.startDate + 'upto' + filters.endDate
            )
          "
        >
          🖨 Print Report
        </button>
      </div>
    </div>

    <div class="filters">
      <label>
        From:
        <input type="date" v-model="filters.startDate" />
      </label>
      <label>
        To:
        <input type="date" v-model="filters.endDate" />
      </label>
      <button class="exclude-print" @click="applyFilters">Apply</button>
      <button class="exclude-print" @click="clearFilters">Clear</button>
    </div>

    <div class="total-expense-place">
      <h4>Total Expenses: {{ total_expenses.toLocaleString() }}</h4>
    </div>
    <h5 style="color: black; background-color: wheat">Expense by Categories</h5>
    <table class="transactions-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Category Name</th>
          <th>Amount</th>
          <th>Visual</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(expense, index) in expenses_by_category" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ expense.category_name }}</td>
          <td>{{ expense.total_amount.toLocaleString() }}</td>
          <td>
            <div class="progress-bar-container">
              <div
                class="progress-bar"
                :style="{
                  width: (expense.total_amount * 100) / total_expenses + '%',
                }"
              ></div>
              <span class="progress-text"
                >{{
                  Math.round(
                    ((expense.total_amount * 100) / total_expenses) * 10
                  ) / 10
                }}%</span
              >
            </div>
          </td>
        </tr>
        <tr v-if="expenses.length === 0">
          <td colspan="4" class="no-data">
            No expenses found for selected dates.
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <h5 style="color: black; background-color: wheat">
      Detailed Expenses Report
    </h5>
    <table class="transactions-table">
      <thead>
        <tr>
          <th>Date</th>
          <th>Expense Title</th>
          <th>Description</th>
          <th>Category</th>
          <th>Amount (Ksh.)</th>
          <th>Added By</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(expense, index) in expenses" :key="index">
          <td>{{ expense.expense_date }}</td>
          <td>{{ expense.expense_title }}</td>
          <td>{{ expense.description }}</td>
          <td>{{ expense.category_name }}</td>
          <td>{{ expense.amount.toLocaleString() }}</td>
          <td>{{ expense.added_by_name }}</td>
        </tr>
        <tr v-if="expenses.length === 0">
          <td colspan="4" class="no-data">
            No expenses found for selected dates.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <add_expense_modal
    v-if="show_add_expense_modal"
    @close-add-expense-modal="close_add_modal"
  />
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
import PrintDiv from "../../prints/div_to_pdf";
import add_expense_modal from "./modals/add_expense_modal.vue";
export default {
  data() {
    return {
      expenses: [],
      filters: {
        startDate: "",
        endDate: "",
      },
      expenses_by_category: [],
      total_expenses: 0,
      filteredExpenses: [],
      show_add_expense_modal: false,
    };
  },
  components: {
    add_expense_modal,
  },
  methods: {
    getToday() {
      const today = new Date();
      return today.toISOString().split("T")[0];
    },
    close_add_modal() {
      this.show_add_expense_modal = false;
      this.request_api_data();
    },
    open_add_modal() {
      this.show_add_expense_modal = true;
    },
    printReport(div, name) {
      return PrintDiv(div, name);
    },
    async request_api_data() {
      var req_body = {
        start_date: this.filters.startDate,
        end_date: this.filters.endDate,
      };

      const url = `getExpenses_by_range`;
      const res = await generalApiRequest(url, "GET", req_body, 1);
      this.expenses = res.data.expenses;
      this.expenses_by_category = res.data.expenses_by_category;
      this.total_expenses = res.data.total_expenses;
      //   console.log(res);
    },
    applyFilters() {
      this.request_api_data();
    },
    clearFilters() {
      this.filters.startDate = this.getToday();
      this.filters.endDate = this.getToday();
      this.applyFilters();
    },
  },
  mounted() {
    this.request_api_data();
  },
  created() {
    const today = this.getToday();
    this.filters.startDate = today;
    this.filters.endDate = today;
    this.applyFilters();
  },
};
</script>

<style scoped>
.expenses-report {
  max-width: 950px;
  margin: 30px auto;
  padding: 20px;
  background: #fafafa;
  border: 1px solid #ddd;
  border-radius: 12px;
}
.total-expense-place {
  margin-bottom: 30px;
  background: #ffe6e6;
  padding: 15px;
  border-radius: 8px;
}

.header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header-bar h2 {
  margin: 0;
  font-size: 1.6rem;
}

.actions button {
  margin-left: 10px;
  padding: 8px 14px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
}

.actions button:hover {
  background: #218838;
}

.filters {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 20px;
}

.filters label {
  font-weight: 500;
}

.filters input {
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
}

.filters button {
  padding: 7px 14px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.filters button:hover {
  background: #0069d9;
}

/* .expenses-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.expenses-table th,
.expenses-table td {
  padding: 12px 14px;
  border: 1px solid #ddd;
  text-align: left;
}

.expenses-table th {
  background: #f4f4f4;
} */

.transactions-table {
  width: 100%;
  border-collapse: collapse;
}

.transactions-table th,
.transactions-table td {
  border: 1px solid #ddd;
  padding: 4px 6px;
  /* font-size: 13px; */
}

.transactions-table th {
  background: #f0f0f0;
  text-align: left;
}

.transactions-table tr:nth-child(even) {
  background: #fafafa;
}

.transactions-table .no-data {
  text-align: center;
  padding: 10px;
  font-style: italic;
}

.no-data {
  text-align: center;
  color: #888;
  font-style: italic;
}
</style>
